import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import WorkIcon from '@mui/icons-material/Work';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Dashboard from '../components/Dashboard';
import { formatCurrency } from '../utils/helpers';

const navItems = [
  { label: 'Overview', icon: <WorkIcon /> },
  { label: 'Available Bookings', icon: <AssignmentIcon /> },
  { label: 'Earnings', icon: <AttachMoneyIcon /> },
  { label: 'Availability', icon: <CalendarTodayIcon /> },
];

function InternDashboard() {
  return (
    <Dashboard title="Intern Portal" navItems={navItems}>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
        Welcome back!
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 4 }}>
        Here is your intern dashboard overview.
      </Typography>

      {/* Summary Cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={0} variant="outlined">
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography color="text.secondary" variant="body2">
                Completed
              </Typography>
              <Typography variant="h4" sx={{ fontWeight: 700, color: '#1e3a8a' }}>
                0
              </Typography>
              <Typography variant="caption" color="text.secondary">
                assessments
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={0} variant="outlined">
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography color="text.secondary" variant="body2">
                Total Earnings
              </Typography>
              <Typography variant="h4" sx={{ fontWeight: 700, color: '#16a34a' }}>
                {formatCurrency(0)}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                lifetime
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={0} variant="outlined">
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography color="text.secondary" variant="body2">
                Referral Bonus
              </Typography>
              <Typography variant="h4" sx={{ fontWeight: 700, color: '#7c3aed' }}>
                {formatCurrency(0)}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                earned
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={0} variant="outlined">
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography color="text.secondary" variant="body2">
                Rating
              </Typography>
              <Typography variant="h4" sx={{ fontWeight: 700 }}>
                --
              </Typography>
              <Typography variant="caption" color="text.secondary">
                avg score
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Available Bookings */}
      <Paper variant="outlined" sx={{ p: 3, mb: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Available Bookings
          </Typography>
          <Chip label="0 available" size="small" />
        </Box>
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography color="text.secondary">
            No bookings available right now. Check back soon!
          </Typography>
        </Box>
      </Paper>

      {/* Availability Calendar Placeholder */}
      <Paper variant="outlined" sx={{ p: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
          Your Availability
        </Typography>
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography color="text.secondary" sx={{ mb: 2 }}>
            Set your available hours so clients can book you.
          </Typography>
          <Button variant="outlined">
            Edit Availability
          </Button>
        </Box>
      </Paper>
    </Dashboard>
  );
}

export default InternDashboard;
